export default __webpack_public_path__ + "static/white-stone-b104113de6c356725f87abbb98ee7e57.jpg";